import {Component, inject} from '@angular/core';
import {GridEventOutput, GridModel} from 'src/app/shared/model/page-grid';
import {Client, ClientData} from '../../service/client.model';
import {ClientGridService} from '../../service/client-grid.service';
import {ModalService} from 'src/app/shared/service/modal/modal.service';
import {ClientModalComponent} from '../modal/client-modal.component';
import {Observable} from 'rxjs';
import {TramsDataSourceModel} from '../../../payments/models/trams-data-source';
import {TramsDataSourceService} from 'src/app/payments/service/trams-data-source.service';

@Component({
    selector: 'app-client-list',
    templateUrl: './client-list.component.html',
    standalone: false
})
export class ClientListComponent {
  private modalService = inject(ModalService);
  private tramsDataSourceService = inject(TramsDataSourceService);

  protected readonly clientsGrid: GridModel<ClientData> = {
    gridDataTestId: 'client-list',
    gridTitle: 'Clients',
    replayButton: true,
    singleColumnFilter: true,
    columns: [
      {
        columnProperty: 'id',
        columnHeader: 'FMS Client Number',
        sort: true,
        clickable: true,
      },
      {
        columnProperty: 'firstName',
        columnHeader: 'Client Name',
        sort: true,
        columnPropertyFunction: (item: Client) => `${item.firstName ?? ''} ${item.middleName ?? ''} ${item.lastName ?? ''}`,
      },
      {
        columnProperty: 'agent.agentName',
        columnPropertyFunction: (client: Client) => `${client.agent?.agentName ?? ''}`,
        columnHeader: 'Primary Agent Name',
        sort: true,
      },
      {
        columnProperty: 'tramsDataSource.sourceName',
        columnPropertyFunction: (client: Client) => `${client.tramsDataSource?.sourceName ?? ''}`,
        columnHeader: 'Data Source',
        sort: true,
      },
      {
        columnProperty: 'tramsCentralDocumentId',
        columnHeader: 'Trams Central Document Number',
        sort: true,
      },
    ],
    filters: [
      {
        filterProperty: 'clientName',
        filterDisplayName: 'Client Name',
        filterType: 'AUTOCOMPLETE',
        config: {
          autocompleteTableName: 'Client',
          autocompleteColumnName: 'ProfileName',
          autocompleteEmitText: true
        }
      },
      {
        filterProperty: 'agentName',
        filterDisplayName: 'Agent Name',
        filterType: 'AUTOCOMPLETE',
        config: {
          autocompleteTableName: 'Agent',
          autocompleteColumnName: 'AgentName',
          autocompleteEmitText: true
        }
      },
      {
        filterProperty: 'dataSource',
        filterDisplayName: 'Data Source',
        filterType: 'DROPDOWN',
        config: {
          dropdownOptions: this.getDataSources(),
          dropdownValueProp: 'id',
          dropdownDisplayWith: (item: TramsDataSourceModel) => item.sourceName
        }
      },
    ],
    gridGetService: inject(ClientGridService)
  };

  private getDataSources(): Observable<TramsDataSourceModel[]> {
    return this.tramsDataSourceService.getTramsDataSourceList();
  }

  openModal({ item }: GridEventOutput<Client>): void {
    if (item.id) {
      this.modalService.open(ClientModalComponent, { width: '55%', data: item.id});
    }
  }
}
